import { logger } from 'redux-logger';

import {
  type Action,
  configureStore,
  combineReducers,
  type Middleware,
  type ConfigureStoreOptions
} from '@reduxjs/toolkit';

import {
  state as authState,
  reducer as authReducer
} from '@/redux/auth';

import {
  state as userState,
  reducer as userReducer
} from '@/redux/user';

import {
  state as quizzesState,
  reducer as quizzesReducer
} from '@/redux/quizzes';

import {
  state as campaignState,
  reducer as campaignReducer
} from '@/redux/campaign';

import {
  state as challengesState,
  reducer as challengesReducer
} from '@/redux/challenges';

const initialState = {
  auth: authState,
  user: userState,
  quizzes: quizzesState,
  campaign: campaignState,
  challenges: challengesState
};

const rootStoreConfig: ConfigureStoreOptions<typeof initialState> = {
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      [import.meta.env.DEV && logger].filter(Boolean) as Middleware[]
    ),

  devTools: import.meta.env.DEV,
  preloadedState: initialState,

  reducer: combineReducers({
    challenges: challengesReducer,
    campaign: campaignReducer,
    quizzes: quizzesReducer,
    user: userReducer,
    auth: authReducer
  })
};

const Store = configureStore(rootStoreConfig);

export type RootState = ReturnType<typeof Store.getState>;

export default Store as typeof Store & {
  dispatch: (state: RootState) => Action;
};
